var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-cell-item',{staticClass:"news",attrs:{"title":_vm.name,"brief":_vm.ctime,"arrow":""},on:{"click":_vm.show_children}},[(_vm.showchildren)?_c('p',{staticClass:"new-content",attrs:{"slot":"children"},domProps:{"innerHTML":_vm._s(_vm.content)},slot:"children"}):_vm._e(),_vm._v(" "),_c('span',{attrs:{"slot":"right"},slot:"right"},[_vm._v("More")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01599e02","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/newitem.vue
// module id = null
// module chunks = 